module.exports = __webpack_public_path__ + "static/media/clock-counter-clockwise-fill.a1617a74.svg";